import type {
  HubGlobalClass,
  HubLiveClasses,
} from '@robovision/hub'


interface ClassParams {
  color: string
  createdAt?: Date
  datapools?: string[]
  id: string
  name?: string
}

export class Class {
  static readonly modelName = 'Class'

  public readonly color: string
  public readonly createdAt?: Date
  public readonly datapools?: string[]
  public readonly id: string
  public readonly name?: string

  public constructor (params: ClassParams) {
    this.color = params.color
    this.createdAt = params.createdAt
    this.datapools = params.datapools ?? []
    this.id = params.id
    this.name = params.name

    Object.freeze(this)
  }

  public get defaultColor (): string {
    return this.color
  }

  public get deletable (): boolean {
    return !this.datapools?.length
  }

  public get inUse (): boolean {
    return !!this.datapools?.length
  }

  public static fromResponse (data: HubGlobalClass): Class {
    return new Class({
      color: data.color,
      createdAt: data.createdAt ? new Date(data.createdAt) : undefined,
      datapools: data.datapools,
      id: data.id,
      name: data.name,
    })
  }

  public static fromLiveClasses (data: HubLiveClasses, onlyInUse = false): Class[] {
    return data.nodeKeys.flatMap(key => {
      const classes = onlyInUse ? key.classes.filter(c => c.inUse) : key.classes
      return classes.map(data => new Class({
        color: data.color,
        id: data.id,
        name: data.name,
      }))
    })
  }
}
